/*
	Сырой каталог стран/языков с API для выпадающих списков (не выбранные значения формы).
	Ключ: buyer_id + customer_id, без привязки к sessionId.
*/

import type {
	GeoCountry,
	Language,
} from "../../../../../../../../../shared/api/catalogs/catalogs";

const getRawCountriesKey = (buyerId: number, customerId: string) =>
	`ba-raw-geo-countries-${buyerId}-${customerId}`;

const getRawLanguagesKey = (buyerId: number, customerId: string) =>
	`ba-raw-languages-${buyerId}-${customerId}`;

const readJsonArray = <T>(raw: string | null): T[] | null => {
	if (!raw) return null;
	try {
		const parsed: unknown = JSON.parse(raw);
		return Array.isArray(parsed) ? (parsed as T[]) : null;
	} catch {
		return null;
	}
};

export const getRawGeoCountriesCatalog = (
	buyerId: number,
	customerId: string,
): GeoCountry[] | null => {
	return readJsonArray<GeoCountry>(
		localStorage.getItem(getRawCountriesKey(buyerId, customerId)),
	);
};

export const setRawGeoCountriesCatalog = (
	buyerId: number,
	customerId: string,
	countries: GeoCountry[],
) => {
	localStorage.setItem(
		getRawCountriesKey(buyerId, customerId),
		JSON.stringify(countries),
	);
};

export const getRawLanguagesCatalog = (
	buyerId: number,
	customerId: string,
): Language[] | null => {
	return readJsonArray<Language>(
		localStorage.getItem(getRawLanguagesKey(buyerId, customerId)),
	);
};

export const setRawLanguagesCatalog = (
	buyerId: number,
	customerId: string,
	languages: Language[],
) => {
	localStorage.setItem(
		getRawLanguagesKey(buyerId, customerId),
		JSON.stringify(languages),
	);
};
